import script from "./SMSCampaignsTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./SMSCampaignsTable.vue?vue&type=script&lang=ts&setup=true"

import "./SMSCampaignsTable.vue?vue&type=style&index=0&id=52cd21b2&lang=scss"

const __exports__ = script;

export default __exports__